export const userRolesEnum = {
  JSMAdmin: 'JSMAdmin',
  Admin: 'Admin',
  MasterAdmin: 'MasterAdmin',
}
